import React from 'react';
import { axiosRequestData } from '../helpers/axios';

type SurveyAnsweredResponse = {
    isSurveyAnswered: boolean | undefined;
    loading: boolean;
};
type SurveyType = 'welcome' | 'guided_journey';

export default function useSurveyAnswered(surveyType: SurveyType): SurveyAnsweredResponse {
    const [isSurveyAnswered, setIsSurveyAnswered] = React.useState<boolean | undefined>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const fetchData = async () => {
        setLoading(true);
        const req = {
            survey_type: surveyType,
        };
        axiosRequestData('POST', '/wp-json/pg/v1/user/survey_answered', req)
            .then(res => {
                if (res.data.answered === true) {
                    setIsSurveyAnswered(true);
                } else if (res.data.answered === false) {
                    setIsSurveyAnswered(false);
                }
                setLoading(false);
            })
            .catch(e => {
                console.log('Unexpected error when fetching survey answered status: ', e);
                setLoading(false);
            });
    };

    React.useEffect(() => {
        fetchData();
    }, []);

    return { isSurveyAnswered, loading };
}